import { combineReducers, ReducersMapObject } from 'redux';
import {
  AppState,
  preferencesReducer,
  userReducer,
  layoutReducer,
  parametersReducer,
  reportReducer,
  errorReducer,
  dashboardReducer,
  reprocessReducer,
  notificationsReducer,
  exportsReducer,
  synchroReducer,
  managementReportReducer,
  parametricStoresReducer,
} from '../../state';

const rootReducers: ReducersMapObject<AppState, never> = {
  preferences: preferencesReducer,
  user: userReducer,
  layout: layoutReducer,
  parameters: parametersReducer,
  report: reportReducer,
  error: errorReducer,
  dashboard: dashboardReducer,
  reprocess: reprocessReducer,
  notifications: notificationsReducer,
  exports: exportsReducer,
  synchro: synchroReducer,
  managementReport: managementReportReducer,
  parametricStores: parametricStoresReducer,
};

export default combineReducers(rootReducers);
